var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleOff({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 18",
    width: 31,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        tspan { white-space:pre }\n        .shp0 { fill: #e3e3e3 }\n        .shp1 { fill: #ffffff }\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "button-toggle-off"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BG-2",
    className: "shp0",
    d: "M9.75 0L21.75 0C26.73 0 30.75 4.02 30.75 9L30.75 9C30.75 13.98 26.73 18 21.75 18L9.75 18C4.77 18 0.75 13.98 0.75 9L0.75 9C0.75 4.02 4.77 0 9.75 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval-2",
    className: "shp1",
    d: "M9.75 2.25C13.48 2.25 16.5 5.27 16.5 9C16.5 12.73 13.48 15.75 9.75 15.75C6.02 15.75 3 12.73 3 9C3 5.27 6.02 2.25 9.75 2.25Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleOff);
export default __webpack_public_path__ + "static/media/toggle-off.425984d88a1e452fee1d15935c7af30a.svg";
export { ForwardRef as ReactComponent };